import * as React from "react";
import type { SVGProps } from "react";
const SvgMail02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M2.4 9.77v8.726a2.4 2.4 0 0 0 2.4 2.4h14.4a2.4 2.4 0 0 0 2.4-2.4v-9.29M2.4 9.77a1.2 1.2 0 0 1 .564-1.017L12 3.104l8.988 5.056a1.2 1.2 0 0 1 .612 1.046M2.4 9.77c.48 0 9.6 5.935 9.6 5.935l9.6-6.498"
    />
  </svg>
);
export default SvgMail02;
